export enum AppRoutes {
  LOGIN = '/log-in',
  AUTHENTICATOR = 'authenticator',
  SIGN_UP = '/sign-up',
  MAIN = '/main',
  FORGOT_PASSWORD = '/forgot-password',
  INACTIVE_LINK = '/inactive-link',
  CONGRATULATIONS = '/reset-congratulations',
  PROFILE = '/main/profile/general',
  NOTIFICATIONS = '/main/profile/notifications',
  DATA_PRIVACY = '/main/profile/data-privacy',
  SECURITY = '/main/profile/security',
  ACTIVE_SESSIONS = '/main/profile/active-sessions',
  SETTINGS = '/main/settings',
  SETTINGS_GENERAL = '/main/settings/general',
  CATEGORIES = '/main/settings/categories',
  ROLES = '/main/settings/roles',
  CONTENT = '/main/settings/content',
  SUBSCRIPTION = '/main/settings/subscription',
  INVENTORY_EDIT = '/main/inventory/edit',
  INVENTORY_LIST = '/main/inventory/items-list',
}
